import {
  createContext, useCallback, useMemo, useState,
} from 'react';
import Category from '../models/Category/Category';

import categoryAPI from '../services/pageTemplateCategory';
import { PaginationMetaLink } from '../models/Paginator';

interface CategoryContextProps {
  pageCategories?: Category[],
  total: number
  currentPage?: number
  links?: PaginationMetaLink[]
  requestPageCategoryList?: (page?: number) => Promise<void>,
  handleSave?: (category: Category) => Promise<void>
  handleDelete?: (id: string) => Promise<void>
}

export const PageTemplateCategoriesContext = createContext<CategoryContextProps>({
  pageCategories: [],
  total: 0,
});

interface Props {
  children: JSX.Element
}

const PageTemplateCategoriesProvider = ({ children }: Props) => {
  const [categoryList, setCategoryList] = useState<Category[]>([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [links, setLinks] = useState(null);

  const postOk = useCallback(() => {
    // console.log('successfully on creating category');
  }, []);

  const postNg = useCallback((err: any) => {
    console.error('error at create category', err);
  }, []);

  const handleSave = useCallback((category: Category) => {
    if (category.id === '') {
      return categoryAPI.post(category).then(postOk).catch(postNg);
    }
    return categoryAPI.put(category).then(postOk).catch(postNg);
  }, [postOk, postNg]);

  const handleDelete = useCallback((id: string) => categoryAPI.destroy(id).then(postOk).catch(postNg), [postOk, postNg]);

  const requestPageCategoryList = useCallback(() => categoryAPI.get().then((res) => {
    if (res == null || res.data == null) {
      return;
    }
    const cList = res.data.data ?? [];
    setCategoryList(cList);
    setTotal(res.data.meta.total);
    setLinks(res.data.meta.links);
    setCurrentPage(res.data.meta.current_page);
  }), []);

  const value = useMemo<CategoryContextProps>(() => ({
    pageCategories: categoryList,
    requestPageCategoryList,
    handleSave,
    handleDelete,
    total,
    currentPage,
    links,
  }), [categoryList, requestPageCategoryList, handleSave, handleDelete, total, currentPage, links]);

  return (
    <PageTemplateCategoriesContext.Provider value={value}>
        {children}
    </PageTemplateCategoriesContext.Provider>
  );
};

export default PageTemplateCategoriesProvider;
